export const ezoButtonPrimaryStyles =
  'bg-ezo-primary hover:bg-ezo-shaded-primary active:bg-ezo-shaded-primary';

export const ezoButtonOutlinedStyles =
  'border-ezo-secondary text-ezo-secondary hover:border-ezo-secondary hover:[background-color:color-mix(in_srgb,var(--ezo-secondary)_10%,transparent)]';

export const ezoButtonOutlinedPrimaryStyles = 'border-ezo-primary text-ezo-primary';

export const ezoButtonLinkStyles = 'text-ezo-secondary';

export const ezoToggleButtonCheckedStyles =
  'has-[:checked]:border-ezo-primary has-[:checked]:bg-ezo-primary has-[:checked]:text-white hover:has-[:checked]:bg-ezo-shaded-primary has-[:checked]:z-1';

// Tapas v8 renders calendar days as Buttons flagged with `data-selected-single`; the old
// `.Tapas-DatePicker__Button` class now belongs to the input's calendar/clear icon buttons.
export const ezoDatePickerSelectedDayStyles =
  '[&_[data-selected-single=true]]:bg-ezo-primary [&_[data-selected-single=true]]:hover:bg-ezo-shaded-primary [&_[data-selected-single=true]]:active:bg-ezo-shaded-primary';

export const ezoTimePickerSelectedStyles = `border-ezo-primary ${ezoButtonPrimaryStyles}`;

export const ezoChipStyles =
  'border-ezo-menu-item-individually-packaged-background bg-ezo-menu-item-individually-packaged-background';
